export const rolletypeSortValue = (rolletype: string) => {
  return (
    {
      'rolletype.erverver': 1,
      'rolletype.overdrager': 2,
      'rolletype.tillitsmann': 3,
    }[rolletype] || 999
  );
};
